import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {Tooltip,Icon} from 'antd'
const allTackTitle= [
    //1
    {
        title: '任务ID',
        dataIndex: 'task_id',
        key: 'task_id',
        width:80,
        fixed: 'left',
        render: (text,record) => {
            return <span>{record.task_id}</span>;
        }
    },
    //2
    {
        title: '任务名',
        dataIndex: 'name',
        key: 'name',
        width:240,
        render: (text,record) => {
            return <Link target={'_blank'} to={`/questionmanage/questionevaluating/evaluatingdetail/${record.task_id}`}>{text}</Link>;
        }
    },
    //3
    {
        title: '创建时间',
        key: 'create_time',
        width:120,
        render: (text,record) => (
            record.create_time&&
             <span>{record.create_time.split(' ')[0]}</span>
        )
    },
    //4
    {
        title: '返工时间',
        key: 'rework_time',
        width:120,
        render: (text,record) => (
            record.rework_time&&
            <span>{record.rework_time.split(' ')[0]}</span>
        )
    },
    //5
    {
        title: '成功时间',
        dataIndex: 'success_time',
        key: 'success_time',
        width:120,
        render: (text,record) => (
            record.success_time&&
            <span>{record.success_time.split(' ')[0]}</span>
        )
    },
//6
    {
        title: <span>总题数</span>,
        width:240,
        render: (text, record) => (
            <span>{record.question_count}</span>

        )
    },
    //7
    {
        title: <span>基础题/计算题</span>,
        width:160,
        render: (text, record) => (
            <span>{record.question_base_count}/{record.question_calculation_count}</span>

        )
    },
    //8
    {
        title: <span>标记计算题/计算题
            <Tooltip
                title={<div>
                    <div>
                        <div>
                            标记基础(计算)题是指标记为课后题和扩展题的题目
                        </div>


                    </div>
                </div>}
                mouseEnterDelay={0.5}>
            <Icon type="question-circle-o" style={{marginLeft:5,color:'#1890ff',cursor: 'help'}} />
            </Tooltip></span>,
        width:160,
        render: (text, record) => (
            <span>{record.question_sign_calculation_count}/{record.question_calculation_count}

            </span>

        )
    },
    //9
    {
        title: <span>标记基础题/基础题</span>,
        width:160,
        render: (text, record) => (
            <span>{record.question_sign_base_count}/{record.question_base_count}</span>

        )
    },
    //10
    {
        title: <span>通过/修改</span>,
        width:160,
        render: (text, record) => (
            <span>{record.question_count_checkpass}/{record.question_count_checkmodify}</span>
        )
    },
    //11
    {
        title: <span>返工原因</span>,
        width:160,
        render: (text, record) => (
            <span>{record.mark}</span>

        )
    },
    // {
    //     title: <span>基础题/计算题</span>,
    //     width:240,
    //     render: (text, record) => (
    //         <span>{record.question_base_count}/{record.question_calculation_count}</span>
    //
    //     )
    // },
    //0
    {
        title: '状态',
        dataIndex: 'stage_name',
        key: 'stage_name',
        width:80,
    },

    //1
    {
        title: '标记员',
        dataIndex: 'sign_user_name',
        key: 'sign_user_name',
        width:120,
        render: (text, record) => (
            <span>{record.sign_user_name||'-'}</span>
        )
    },

    //2
    {
        title: '审核员',
        dataIndex: 'check_user_name',
        key: 'check_user_name',
        width:120,
        render: (text, record) => (
            <span>{record.check_user_name||'-'}</span>
        )
    },
]



const getFilterColumns=(role,type)=>{
    if(!role){
        return [];
    }

    let r = []
    switch (type){
        case 'pre_assign':
            r = role.columns[0]
            break;
        case 'signing':
            r = role.columns[1]
            break;
        case 'pre_check':
            r = role.columns[2]
            break;

        case 'checking':
            r = role.columns[3]
            break;
        case 'rework':
            r = role.columns[4]
            break;
        case 'check_pass':
            r = role.columns[5]
            break;
        case 'online_ing':
            r = role.columns[6]
            break;
        case 'online_success':
            r = role.columns[7]
            break;
        case 'online_fail':
            r = role.columns[8]

            break;
        default:
            break;
    }
    //判断按钮是否显示
    let arr=[]
    allTackTitle.forEach((d,i)=>{
        if(r[i]){
            arr.push(d)
        }
    })
    return arr
}
export {getFilterColumns}


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_evaluating/evaluating_task_list/columns.js